import { BackendKeywordTag } from '../../constants/tags'

export const getLocalizedName = (keyword: BackendKeywordTag, language: string): string => {
  const hungarian = (keyword.Name || '').trim()
  const english = (keyword.EN_Name || '').trim()

  if (language.startsWith('en')) {
    return english || hungarian
  }

  return hungarian || english
}

export const getFirstHungarianLetter = (text: string): string => {
  const upperText = text.toLocaleUpperCase('hu-HU')

  // Hungarian digraphs and trigraphs (order matters - check longer ones first)
  const hungarianLetters = ['DZS', 'CS', 'GY', 'LY', 'NY', 'SZ', 'TY', 'ZS', 'DZ']

  for (const letter of hungarianLetters) {
    if (upperText.startsWith(letter)) {
      return letter
    }
  }

  // If no digraph/trigraph, return the first character
  const firstChar = upperText.charAt(0)
  return /^[A-ZÁÉÍÓÖŐÚÜŰ]$/.test(firstChar) ? firstChar : '#'
}

export const getKeywordSizeLevel = (count: number, minCount: number, maxCount: number): number => {
  if (maxCount === minCount) return 0
  if (count <= 4) return -1
  if (count <= 19) return 0
  if (count <= 49) return 1
  if (count <= 99) return 2
  if (count <= 199) return 3
  return 4
}
